import { ORACLE_URL_V1, ORACLE_URL_V2, SUBGRAPH_URL_V1, SUBGRAPH_URL_V2 } from '@/global/configs/common.config';
import { ProjectState } from '@/global/enums/project.enum';

import { generateAxios } from './utils';

const apiClientV1 = generateAxios(ORACLE_URL_V1);
const apiClientV2 = generateAxios(ORACLE_URL_V2);
const subgraphClientV1 = generateAxios(SUBGRAPH_URL_V1);
const subgraphClientV2 = generateAxios(SUBGRAPH_URL_V2);

export { apiClientV1, apiClientV2, subgraphClientV1, subgraphClientV2 };
